import React, { memo, useEffect, useState } from "react"
import {
  Button,
  CardBody,
  Col,
  Form,
  FormFeedback,
  FormGroup,
  Input,
  InputGroup,
  InputGroupText,
  Label,
  Row,
} from "reactstrap"
import ModalLeavingWork from "./ModalLeavingWork"
import { useDispatch, useSelector } from "react-redux"
import AttendanceAction from "store/attendance-resource/actions"
import Timer from "./Timer"
import Skeleton from "react-loading-skeleton"

const LeftSide = ({
  validation,
  isUpdate,
  setIsUpdate,
  setIsModal,
  isModal,
}) => {
  const { values } = validation
  const dispatch = useDispatch()
  const store = useSelector(state => state)

  const hourSummary = React.useMemo(() => {
    let totalHour = values.assignments
      .filter(i => i.checked)
      .map(i => Number(i.hour))
      .reduce((a, b) => a + b, 0)
    let totalMinute = values.assignments
      .filter(i => i.checked)
      .map(i => Number(i.minute))
      .reduce((a, b) => a + b, 0)

    if (totalMinute >= 60) {
      let tempHour = Number(String(totalMinute / 60).split(".")[0])
      let tempMinute = tempHour * 60
      totalMinute -= tempMinute
      totalHour += tempHour
    }

    let otherWorkHour = values.otherWorks
      .map(i => Number(i.hour))
      .reduce((a, b) => a + b, 0)
    let otherWorkMinute = values.otherWorks
      .map(i => Number(i.minute))
      .reduce((a, b) => a + b, 0)

    if (otherWorkMinute >= 60) {
      let tempHour = Number(String(otherWorkMinute / 60).split(".")[0])
      let tempMinute = tempHour * 60
      otherWorkMinute -= tempMinute
      otherWorkHour += tempHour
    }

    totalMinute =
      totalMinute + otherWorkMinute + Number(values.inspectionMinute)
    totalHour = totalHour + otherWorkHour + Number(values.inspectionHour)

    if (totalMinute >= 60) {
      let tempHour = Number(String(totalMinute / 60).split(".")[0])
      let tempMinute = tempHour * 60
      totalMinute -= tempMinute
      totalHour += tempHour
    }

    return { totalHour, totalMinute }
  }, [
    values.assignments,
    values.otherWorks,
    values.inspectionHour,
    values.inspectionMinute,
  ])

  React.useEffect(() => {
    callbackClockIn()
  }, [])

  useEffect(() => {
    if (isUpdate) {
      setTimeout(() => {
        callbackClockIn()
      }, 1000)
    }
    setIsUpdate(false)
  }, [isUpdate])

  const callbackClockIn = () => {
    dispatch(AttendanceAction.getAttendanceToday())
  }

  return (
    <>
      <ModalLeavingWork
        setIsModal={setIsModal}
        isModal={isModal}
        validation={validation}
        setIsUpdate={setIsUpdate}
      />
      <Col
        sm="12"
        className="d-flex align-items-center justify-content-start flex-column"
      >
        <Timer />
        {store.attendance.clockIn.loading ? (
          <Skeleton width={500} height={30} />
        ) : (
          <Button
            className="w-50 mb-2 rounded-0 button"
            disabled={store.attendance.today.data?.clockIn !== null}
            onClick={() => {
              dispatch(AttendanceAction.postClockIn(callbackClockIn))
              setIsUpdate(true)
            }}
          >
            出勤
          </Button>
        )}

        {store.attendance.clockOut.loading ? (
          <Skeleton width={500} height={30} />
        ) : (
          <Button
            type="submit"
            className="w-50 mb-2 rounded-0 button"
            disabled={
              store.attendance.today.data?.clockOut ||
              store.attendance.today.data?.clockIn === null
            }
          >
            退勤
          </Button>
        )}

        <div className="w-50">
          <label>備考</label>
          <Input
            type="textarea"
            name="remarks"
            className="form-control"
            value={validation.values.remarks || ""}
            onChange={validation.handleChange}
            onBlur={validation.handleBlur}
            invalid={
              validation.touched.remarks && validation.errors.remarks
                ? true
                : false
            }
          />
          {validation.touched.remarks && validation.errors.remarks ? (
            <FormFeedback type="invalid">
              {validation.errors.remarks}
            </FormFeedback>
          ) : null}
        </div>

        <div className="w-50 mt-3">
          <label>累計作業時間</label>
          <Row>
            <Col lg="6">
              <InputGroup>
                <Input
                  name="totalHour"
                  className="form-control"
                  value={hourSummary?.totalHour || ""}
                  disabled
                />
                <InputGroupText>時間</InputGroupText>
              </InputGroup>
            </Col>

            <Col lg="6">
              <InputGroup>
                <Input
                  name="totalMinute"
                  className="form-control"
                  value={hourSummary?.totalMinute || ""}
                  disabled
                />
                <InputGroupText>分</InputGroupText>
              </InputGroup>
            </Col>
          </Row>
        </div>
      </Col>
    </>
  )
}

export default memo(LeftSide)
